import {
  Backdrop,
  ButtonPrimary,
  DialogConfirmation,
  Type,
} from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';
import { IS_CLIENT_ENV } from '@helpers/constants';

export const DoNotUseDialog = () => {
  const t = useT();

  let isAtlasSpotifyNet: boolean = false;
  if (IS_CLIENT_ENV) {
    isAtlasSpotifyNet = window.location.href.includes('atlas.spotify.net');
  }

  return isAtlasSpotifyNet ? (
    <Backdrop center>
      <DialogConfirmation
        aria-label="Do not use site"
        dialogTitle={t(
          'atlas.alert.do_not_use_site',
          `Don't use this site`,
          'Title text of alert modal',
        )}
        body={
          <Type variant="ballad">
            {t(
              'atlas.alert.visit_s4mp',
              'musicproviders.spotify.com is replacing atlas.spotify.net. Visit Spotify for Music Providers to manage your catalog.',
              'Indicates to user to go to S4MP website',
            )}
          </Type>
        }
        footer={
          <ButtonPrimary href="https://musicproviders.spotify.com/catalog">
            {t(
              'atlas.actions.visit_new_site',
              'Visit new site',
              'Indicates to user to go to S4MP website',
            )}
          </ButtonPrimary>
        }
      />
    </Backdrop>
  ) : null;
};
